export const parseMetadata = (metadata) => {
    if (typeof metadata === 'string') {
      try {
        return JSON.parse(metadata);
      } catch (e) {
        console.error('Invalid JSON metadata:', e);
        return null;
      }
    }

    if (typeof metadata === 'object' && metadata !== null) {
      return metadata;
    }

    return null;
}

export const extractCleanImageUrls = (urls) =>
    urls
    .map((url) => {
    try {
        const parsed = new URL(url);
        const path = parsed.pathname;
        const isImage = /\.(jpe?g|png|gif|svg|avif|webp|bmp|tiff)$/i.test(path);
        return isImage ? `${parsed.origin}${parsed.pathname}` : null;
    } catch {
        return null;
    }
    })
    .filter(Boolean);

export const extractCleanAudioUrls = (urls) => urls
        .map((url) => {
        try {
            const parsed = new URL(url);
            const path = parsed.pathname;
            const isAudio = /\.(mp3)$/i.test(path);
            return isAudio ? `${parsed.origin}${parsed.pathname}` : null;
        } catch {
            return null;
        }
        })
        .filter(Boolean)

export const extractCleanVideoUrls = (urls) => urls
        .map((url) => {
        try {
            const parsed = new URL(url);
            const path = parsed.pathname;
            const isVideo = /\.(mp4|webm|ogg|mov|mkv|avi|flv|wmv)$/i.test(path);
            return isVideo ? `${parsed.origin}${parsed.pathname}` : null;
        } catch {
            return null;
        }
        })
        .filter(Boolean)

export const extractNonMediaUrls = (urls) => {
    const mediaPattern = /\.(jpe?g|png|gif|svg|avif|webp|bmp|tiff|mp4|webm|ogg|mp3|wav|mov|aac|m4a|flac)$/i;

    return urls
        .map((url) => {
        try {
            const parsed = new URL(url);
            const path = parsed.pathname;
            return mediaPattern.test(path) ? null : `${parsed.origin}${parsed.pathname}`;
        } catch {
            return null;
        }
        })
        .filter(Boolean);
}
